import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'widget-calendar-date',
    templateUrl: './calendar-date.component.html',
    styleUrls: ['./calendar-date.component.scss'],
    standalone: false
})
export class CalendarDateComponent implements OnInit {

  @Input()
  label:string;

  @Input()
  date:Date;

  // Formato opcional para el pipe nativo `date` (tokens numéricos, p.ej. 'MM-dd-yyyy').
  // Si no se pasa, se mantiene el comportamiento por defecto (pipe formatDate).
  @Input()
  dateFormat?: string;

  @Input()
  type: 'normal' | 'enphasis';

  @Input()
  layoutView: 'list-view' | 'card-view'

  constructor() { }

  ngOnInit() {
  }

  get isCardView() { return this.layoutView === 'card-view'}
  get classCalendar() {
    if(this.layoutView === 'list-view'){
      return 'text-center'
    }
    if(this.layoutView === 'card-view'){
      return 'adjust-card-view'
    }
  }

  get classDateCalendar() {
    if(this.isCardView) {
      return 'text-left';
    } 
  }

}
